import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import brand from '../shell/brand';
import mark from './product-mark.png';

// Who made the product, on the one screen where the reader is not yet doing anything else. It sits
// under the form rather than beside the customer's own name at the top: the tenant's branding is
// about whose yard this is, and this is about whose software it is.
const DevelopedBy = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      py: 2,
      px: 2,
      opacity: 0.85,
    }}
  >
    <Box
      component="img"
      src={brand.developerLogo || mark}
      alt=""
      sx={{ height: 26, width: 'auto', display: 'block' }}
    />
    <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: 0.3 }}>
      Developed by
      {' '}
      {brand.developerUrl ? (
        <Link href={brand.developerUrl} target="_blank" rel="noopener noreferrer" sx={{ fontWeight: 600, color: 'text.primary' }}>{brand.developer}</Link>
      ) : (
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>{brand.developer}</Box>
      )}
    </Typography>
  </Box>
);

export default DevelopedBy;
